// extracted by mini-css-extract-plugin
module.exports = {"white":"link_white__049u9","icon":"link_icon__ja_sB"};